// extracted by mini-css-extract-plugin
export var emptyState = "_6b-d";
export var statCard = "_6b-c";
export var table = "_6b-0";
export var tableCell = "_6b-4";
export var tableCellClickable = "_6b-5 _6b-4";
export var tableCellDefault = "_6b-6 _6b-4";
export var tableCellEmpty = "_6b-8";
export var tableCellWithValue = "_6b-7";
export var tableContainer = "_6b-e";
export var tableHeaderWeight = "_6b-1";
export var tableHeaderZone = "_6b-2";
export var tableRowHeader = "_6b-3";
export var viewModeButton = "_6b-9";
export var viewModeButtonActive = "_6b-a _6b-9";
export var viewModeButtonInactive = "_6b-b _6b-9";